import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
const isV3 = allVue.version && allVue.version[0] === '3'
import { KendoSharedMethods } from '@progress/kendo-base-components-vue-wrapper'

export default {
    name: 'kendo-menu-item',
    setup() {
        const v3 = isV3
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement
        const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ? this.$slots.default() : this.$slots.default
        return h('span', defaultSlot)
    },
    mixins: [
        KendoSharedMethods
    ],
    props:{
        text: {
            type: String,
            default: undefined
        },
        cssClass: {
            type: String,
            default: undefined
        },
        url: {
            type: String,
            default: undefined
        },
        attr: {
            type: Object,
            default: undefined
        },
        encoded: {
            type: Boolean,
            default: undefined
        },
        content: {
            type: String,
            default: undefined
        },
        contentAttr: {
            type: Object,
            default: undefined
        },
        imageAttr: {
            type: Object,
            default: undefined
        },
        imageUrl: {
            type: String,
            default: undefined
        },
        items: {
            type: Array,
            default: undefined
        },
        spriteCssClass: {
            type: String,
            default: undefined
        },
        select: Function
    },
    mounted() {
        this._resolveInnerChildren()
    },
    methods: {
        _resolveInnerChildren() {
            const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ? this.$slots.default() : this.$slots.default
            const hasItems = this.v3 ? (!this.$props.items) : (this.$options.propsData && !this.$options.propsData['items'])
            if(hasItems && defaultSlot){
                var items = this.resolveInnerTags('kendo-menu-item')
                this.subitems = items
            }
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoMenu/KendoMenuItem.js